import type { ExcelColumn } from '../../../utils/excelExport';

export const DASHBOARD_ORDER_EXPORT_COLUMNS: ExcelColumn[] = [
  { header: 'Merchant', key: 'merchantName' },
  { header: 'TXN ID', key: 'transactionId' },
  { header: 'Amount', key: 'amount' },
  { header: 'Status', key: 'status' },
  { header: 'Date / Time', key: 'orderTime' },
];

export const DASHBOARD_PERIODS = ['7D', '30D', '90D', 'YTD', 'All'] as const;

export const DASHBOARD_PAGE_SIZE = 5;

export const MERCHANT_ALLOWED_MODULES: Record<string, string> = {
  '/transaction-dashboard': 'TRAN-MON-09',
  '/transaction-monitoring': 'TRAN-MON-09',
  '/profile': 'PROFILE',
  '/orders/create': 'TRAN-MON-09',
  // Gated by the per-user permission matrix: revoking the module's View actually blocks the route,
  // not just the sidebar link.
  '/developers': 'MERCH-DEVELOPERS',
  '/documentation': 'MERCH-DOCS',
  '/storefront-urls': 'MERCH-STOREFRONT-URLS',
};

// Nothing is unconditionally allowed any more — every merchant page resolves through
// MERCHANT_ALLOWED_MODULES + canView, so an admin's permission override takes effect on the route.
export const MERCHANT_ALWAYS_ALLOWED_PATHS = new Set<string>([]);

// Most merchant routes gate on the module's View. A few are actions, not just a page view — e.g.
// opening the create-order form IS the "Create Order" capability — so they require that flag instead.
export const MERCHANT_PATH_REQUIRED_ACTION: Record<string, 'view' | 'create' | 'update'> = {
  '/orders/create': 'create',
};

export const MERCHANT_ONLY_PATHS = new Set<string>(['/developers', '/documentation', '/storefront-urls']);
